import * as Sentry from "@sentry/react";
import appConfig from "./config";

if (appConfig.SENTRY_DSN) {
  Sentry.init({
    dsn: appConfig.SENTRY_DSN,
    environment: appConfig.REACT_APP_ENV,
    release: appConfig.REACT_APP_SENTRY_RELEASE,
    debug: appConfig.REACT_APP_ENV === "staging",
    tracesSampleRate: 0.1,
  });
}
